import { render } from "./PaymentStep.vue?vue&type=template&id=8d67ec36"
import script from "./PaymentStep.vue?vue&type=script&lang=js"
export * from "./PaymentStep.vue?vue&type=script&lang=js"

import "./PaymentStep.vue?vue&type=style&index=0&id=8d67ec36&lang=css"

import exportComponent from "/home/zhayrullah/projects/laravel/mawthuq/front-mawthuq/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__